export default __webpack_public_path__ + "6ff09d6d4ca431c4c343bb3c21fd08a5.png";